import { render, staticRenderFns } from "./PlmMbomList.vue?vue&type=template&id=3a16ace9&scoped=true"
import script from "./PlmMbomList.vue?vue&type=script&lang=js"
export * from "./PlmMbomList.vue?vue&type=script&lang=js"
import style0 from "./PlmMbomList.vue?vue&type=style&index=0&id=3a16ace9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a16ace9",
  null
  
)

export default component.exports